export default __webpack_public_path__ + "static/adventurer-dfc251eb487ed7feb5d211e1e70fe6e5.png";